var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMaximizeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 7V3.75H17c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75v4c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.47 9.53a.755.755 0 0 1 0-1.06l6-6c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-6 6c-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM3 21.75c-.41 0-.75-.34-.75-.75v-4c0-.41.34-.75.75-.75s.75.34.75.75v3.25H7c.41 0 .75.34.75.75s-.34.75-.75.75H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47 21.53a.755.755 0 0 1 0-1.06l6-6c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-6 6c-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM1.47 14.15c-.14-.7-.22-1.43-.22-2.15C1.25 6.07 6.07 1.25 12 1.25c.73 0 1.46.07 2.17.22.41.08.67.48.59.88-.08.41-.49.66-.88.59-.61-.12-1.24-.19-1.87-.19-5.1 0-9.25 4.15-9.25 9.25 0 .62.06 1.25.19 1.85.08.41-.18.8-.59.88-.06.02-.11.02-.16.02-.35 0-.66-.25-.73-.6zM9.831 22.53a.75.75 0 0 1-.59-.88c.08-.41.49-.66.88-.59.61.12 1.24.19 1.87.19 5.1 0 9.25-4.15 9.25-9.25 0-.62-.06-1.24-.18-1.85a.75.75 0 1 1 1.47-.29c.14.7.21 1.42.21 2.14.01 5.93-4.81 10.75-10.74 10.75-.73 0-1.46-.07-2.17-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMaximizeCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-maximize-circle.e39dfc74c999611a9a584430f7e0d329.svg";
export { ForwardRef as ReactComponent };